// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import store from './store';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

/* 重置样式 */
import './assets/css/main.css'

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery';
import Viewer from 'v-viewer'
Vue.use(Viewer)

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min.js'

/* 国际化插件 */
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)


if (localStorage.getItem("token")) {
  store.commit('updateLogin', true);
}

//创建VueI18n实例
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh', //语言标识
  messages: {
    'zh': require('../src/assets/lang/zh'),
    'en': require('../src/assets/lang/en')
  },
  silentTranslationWarn: true, // 去除国际化警告
})

Vue.config.productionTip = false

/* 头部组件 */
import Header from './components/Header';

Vue.component(Header.name,Header)


// 创建Vue实例之前添加事件监听
Vue.directive('hover', {
  bind(el, binding) {
    // 鼠标移入事件
    el.addEventListener('mouseenter', () => {
      el.classList.add(binding.value.className);
    });

    // 鼠标移出事件
    el.addEventListener('mouseleave', () => {
      el.classList.remove(binding.value.className);
    });
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js